<template>
  <form id="frm_action">
    <div class="p-formgrid">
      <DataTable :value="details" showGridlines responsiveLayout="scroll">
        <Column field="detail" header="Detail"></Column>
        <Column field="data" header="Data"></Column>
      </DataTable>
      <Toolbar class="fixed-bottom-toolbar div-button">
        <template #right>
          <Button :label="$constants.TEXT_BUTTON.BACK" @click="backToList()" class="p-button-outlined" id="back" />
        </template>
      </Toolbar>
    </div>
  </form>
</template>

<script>
export default {
  props: {
    mode: String,
    model: Object, // Dữ liệu object chi tiết nhận từ parent component
    users: Array
  },
  data() {
    return {
      obj_data: {},
      details: [],
      componentKey: 0
    };
  },
  async mounted() {
    if (this.model && Object.keys(this.model).length > 0) {
      this.obj_data = this.model;
      console.log("Loaded data:", this.obj_data);
      
      // Map dữ liệu từ model vào details, hiển thị "-" nếu không có dữ liệu
      this.details = [
        { detail: "Created date", data: this.formatDate(this.obj_data?.created_at) || "-" },
        { detail: "Created by", data: this.obj_data?.obj_created_by?.fullname || "-" },
        { detail: "Payment method", data: this.obj_data?.payment_method || "-" },
        { detail: "Payment status", data: this.obj_data?.status || "-" },
        { detail: "Author", data: this.obj_data?.obj_updated_by?.fullname || "-" },
        { detail: "Order ID", data: this.obj_data?.obj_rental_order?.code || "-" },
        { detail: "Code ID", data: this.obj_data?.code || "-" },
        { detail: "Description", data: this.obj_data?.description || "-" },
        { detail: "Requested amount", data: this.obj_data?.amount ? `$${this.obj_data.amount}` : "-" },
        { detail: `Voucher discount (${this.obj_data?.voucher_code || "N/A"})`, data: this.obj_data?.voucher_discount ? `-$${this.obj_data.voucher_discount}` : "-" },
        { detail: `Redeemed (${this.obj_data?.redeemed || 0} points)`, data: this.obj_data?.redeemed_convert_price ? `-$${this.obj_data.redeemed_convert_price}` : "-" },
        { detail: "Paid amount", data: this.obj_data?.total_payment ? `$${this.obj_data.total_payment}` : "-" },
      ];

      this.componentKey++;
    } else {
      // Nếu model trống, hiển thị dữ liệu mặc định
      this.componentKey++;
    }
  },
  methods: {
    backToList() {
      this.$emit('back');
    },
    formatDate(date) {
      if (!date) return '-';
      const options = { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit' };
      return new Date(date).toLocaleDateString('en-GB', options);
    }
  }
};
</script>
